var map = {
	"./404": [
		1036,
		48
	],
	"./404.vue": [
		1036,
		48
	],
	"./Home": [
		998,
		0,
		13
	],
	"./Home.vue": [
		998,
		0,
		13
	],
	"./InsiderBacktester": [
		990,
		0,
		1,
		12
	],
	"./InsiderBacktester.vue": [
		990,
		0,
		1,
		12
	],
	"./InsiderDashboard": [
		994,
		0,
		1,
		2,
		10
	],
	"./InsiderDashboard.vue": [
		994,
		0,
		1,
		2,
		10
	],
	"./WhaleBacktester": [
		989,
		0,
		1,
		3,
		9
	],
	"./WhaleBacktester.vue": [
		989,
		0,
		1,
		3,
		9
	],
	"./WhaleScreener": [
		999,
		0,
		1,
		3,
		11
	],
	"./WhaleScreener.vue": [
		999,
		0,
		1,
		3,
		11
	],
	"./analytics/Backtester": [
		996,
		0,
		1,
		7
	],
	"./analytics/Backtester.vue": [
		996,
		0,
		1,
		7
	],
	"./analytics/Combined": [
		1000,
		0,
		1,
		39
	],
	"./analytics/Combined.vue": [
		1000,
		0,
		1,
		39
	],
	"./analytics/Consensus": [
		1001,
		0,
		40
	],
	"./analytics/Consensus.vue": [
		1001,
		0,
		40
	],
	"./analytics/DoubleDown": [
		1002,
		0,
		41
	],
	"./analytics/DoubleDown.vue": [
		1002,
		0,
		41
	],
	"./analytics/EarlyBird": [
		1003,
		36
	],
	"./analytics/EarlyBird.vue": [
		1003,
		36
	],
	"./analytics/OverlapMatrix": [
		1004,
		37
	],
	"./analytics/OverlapMatrix.vue": [
		1004,
		37
	],
	"./congress/CongressPersonView": [
		1005,
		0,
		14
	],
	"./congress/CongressPersonView.vue": [
		1005,
		0,
		14
	],
	"./congress/CongressSearch": [
		1006,
		0,
		42
	],
	"./congress/CongressSearch.vue": [
		1006,
		0,
		42
	],
	"./congress/CongressTransactions": [
		1007,
		0,
		43
	],
	"./congress/CongressTransactions.vue": [
		1007,
		0,
		43
	],
	"./global/GlobalHoldingSearch": [
		1008,
		0,
		15
	],
	"./global/GlobalHoldingSearch.vue": [
		1008,
		0,
		15
	],
	"./global/Instrument": [
		1009,
		0,
		16
	],
	"./global/Instrument.vue": [
		1009,
		0,
		16
	],
	"./global/Organization": [
		1010,
		0,
		17
	],
	"./global/Organization.vue": [
		1010,
		0,
		17
	],
	"./mutual_fund/CombinedMutualFund": [
		1011,
		0,
		44
	],
	"./mutual_fund/CombinedMutualFund.vue": [
		1011,
		0,
		44
	],
	"./mutual_fund/MutualFundHoldingsView": [
		1012,
		0,
		18
	],
	"./mutual_fund/MutualFundHoldingsView.vue": [
		1012,
		0,
		18
	],
	"./mutual_fund/MutualFundView": [
		1013,
		0,
		19
	],
	"./mutual_fund/MutualFundView.vue": [
		1013,
		0,
		19
	],
	"./mutual_fund/PortfolioSimilarity": [
		1014,
		38
	],
	"./mutual_fund/PortfolioSimilarity.vue": [
		1014,
		38
	],
	"./other/AdvisorSearch": [
		1015,
		0,
		20
	],
	"./other/AdvisorSearch.vue": [
		1015,
		0,
		20
	],
	"./other/Form144Search": [
		1016,
		0,
		21
	],
	"./other/Form144Search.vue": [
		1016,
		0,
		21
	],
	"./other/Form4Search": [
		1017,
		0,
		22
	],
	"./other/Form4Search.vue": [
		1017,
		0,
		22
	],
	"./other/FormDSearch": [
		1018,
		0,
		23
	],
	"./other/FormDSearch.vue": [
		1018,
		0,
		23
	],
	"./other/HkexTransactions": [
		1019,
		0,
		24
	],
	"./other/HkexTransactions.vue": [
		1019,
		0,
		24
	],
	"./other/LseTransactions": [
		1020,
		0,
		25
	],
	"./other/LseTransactions.vue": [
		1020,
		0,
		25
	],
	"./other/NcenSearch": [
		1021,
		0,
		26
	],
	"./other/NcenSearch.vue": [
		1021,
		0,
		26
	],
	"./other/NsarSearch": [
		1022,
		0,
		27
	],
	"./other/NsarSearch.vue": [
		1022,
		0,
		27
	],
	"./other/Schedule13Search": [
		1023,
		0,
		45
	],
	"./other/Schedule13Search.vue": [
		1023,
		0,
		45
	],
	"./other/TrendFinder": [
		993,
		0,
		1,
		2,
		4,
		8
	],
	"./other/TrendFinder.vue": [
		993,
		0,
		1,
		2,
		4,
		8
	],
	"./search/BiSearch": [
		1024,
		0,
		1,
		28
	],
	"./search/BiSearch.vue": [
		1024,
		0,
		1,
		28
	],
	"./search/FundPerformanceSearch": [
		997,
		0,
		29
	],
	"./search/FundPerformanceSearch.vue": [
		997,
		0,
		29
	],
	"./search/OptionsSearch": [
		1025,
		0,
		46
	],
	"./search/OptionsSearch.vue": [
		1025,
		0,
		46
	],
	"./search/SectorSearch": [
		1026,
		0,
		1,
		47
	],
	"./search/SectorSearch.vue": [
		1026,
		0,
		1,
		47
	],
	"./search/StockScreener": [
		1027,
		0,
		30
	],
	"./search/StockScreener.vue": [
		1027,
		0,
		30
	],
	"./short/ShortDashboard": [
		991,
		0,
		31
	],
	"./short/ShortDashboard.vue": [
		991,
		0,
		31
	],
	"./short/ShortPositionHolder": [
		1028,
		0,
		32
	],
	"./short/ShortPositionHolder.vue": [
		1028,
		0,
		32
	],
	"./short/ShortPositionIssuer": [
		1029,
		0,
		33
	],
	"./short/ShortPositionIssuer.vue": [
		1029,
		0,
		33
	],
	"./user/AccountSettings": [
		992,
		0,
		6
	],
	"./user/AccountSettings.vue": [
		992,
		0,
		6
	],
	"./user/EmailAlerts": [
		1030,
		49
	],
	"./user/EmailAlerts.vue": [
		1030,
		49
	],
	"./user/EmailAlertsCreateEdit": [
		995,
		50
	],
	"./user/EmailAlertsCreateEdit.vue": [
		995,
		50
	],
	"./user/FundGroups": [
		1031,
		51
	],
	"./user/FundGroups.vue": [
		1031,
		51
	],
	"./user/FundGroupsCreateEdit": [
		1032,
		52
	],
	"./user/FundGroupsCreateEdit.vue": [
		1032,
		52
	],
	"./user/StockWatchListCreateEdit": [
		1033,
		53
	],
	"./user/StockWatchListCreateEdit.vue": [
		1033,
		53
	],
	"./user/StockWatchLists": [
		1034,
		0,
		1,
		2,
		4,
		35
	],
	"./user/StockWatchLists.vue": [
		1034,
		0,
		1,
		2,
		4,
		35
	],
	"./user/TrackedBacktests": [
		1035,
		0,
		1,
		5,
		34
	],
	"./user/TrackedBacktests.vue": [
		1035,
		0,
		1,
		5,
		34
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 1219;
module.exports = webpackAsyncContext;